/** Shared constants for the UnifiedProviderCard and related components. */

export const BILLING_TIER_OPTIONS = [
  { value: 'none', label: 'None', description: 'No billing access' },
  { value: 'tier_1', label: 'Tier 1 — Collect Payments', description: 'View balances, create invoices, collect payments' },
  { value: 'tier_2', label: 'Tier 2 — Full Billing', description: 'All Tier 1 + exports, revenue analytics, financial reports' },
] as const;

export const PAY_TYPE_OPTIONS = [
  { value: '', label: 'Not Set' },
  { value: 'w2', label: 'W-2 Employee' },
  { value: '1099', label: '1099 Contractor' },
  { value: 'stipend', label: 'Stipend / Unpaid' },
] as const;

export const TIMESHEET_MODE_OPTIONS = [
  { value: 'full_time', label: 'Full Time' },
  { value: 'part_time', label: 'Part Time' },
  { value: 'per_diem', label: 'Per Diem' },
  { value: 'exempt', label: 'Exempt' },
] as const;

export const SUPERBILL_NPI_OPTIONS = [
  { value: '', label: 'Default (Organization NPI)' },
  { value: 'provider', label: 'Use Provider NPI' },
  { value: 'organization', label: 'Use Organization NPI' },
] as const;

export const TELEHEALTH_MODE_OPTIONS = [
  { value: '', label: 'Default (Organization Setting)' },
  { value: 'disabled', label: 'Disabled' },
  { value: 'video', label: 'Video Only' },
  { value: 'phone', label: 'Phone Only' },
  { value: 'both', label: 'Video & Phone' },
] as const;

export const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL','GA','HI','ID','IL','IN',
  'IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH',
  'NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT',
  'VT','VA','WA','WV','WI','WY',
] as const;
